import type * as SchemaTypes from '../../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitPerformanceWeightResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitWeightResultInput;
}>;


export type SubmitPerformanceWeightResultMutation = (
  { __typename: 'Mutation' }
  & { submitWeightResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'message' | 'field'>
    )>> }
  ) | (
    { __typename: 'SubmitWeightResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'PerformanceResult' }
      & WeightPerformanceResultFragment
    )> }
  ) }
);

export type WeightPerformanceResultFragment = (
  { __typename: 'PerformanceResult' }
  & Pick<SchemaTypes.PerformanceResult, 'id' | 'companyId' | 'userId' | 'isTiedToAssessmentRun' | 'assessmentRunId' | 'createdAt' | 'completedAt' | 'updatedAt' | 'updatedBy' | 'isDeleted'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'role' | 'email'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'BmpResult' } | { __typename: 'FinSwimResult' } | { __typename: 'IpptResult' } | { __typename: 'March20kmResult' } | { __typename: 'SocResult' } | (
    { __typename: 'WeightResult' }
    & WeightPerformanceResultDataFragment
  ) }
);

export type WeightPerformanceResultDataFragment = (
  { __typename: 'WeightResult' }
  & Pick<SchemaTypes.WeightResult, 'weightKg'>
);

export const WeightPerformanceResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment WeightPerformanceResultData on WeightResult {
  weightKg
}
    `;
export const WeightPerformanceResultFragmentDoc = /*#__PURE__*/ gql`
    fragment WeightPerformanceResult on PerformanceResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      role
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  isTiedToAssessmentRun
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on WeightResult {
      ...WeightPerformanceResultData
    }
  }
  createdAt
  completedAt
  updatedAt
  updatedBy
  isDeleted
}
    `;
export const SubmitPerformanceWeightResultDocument = /*#__PURE__*/ gql`
    mutation SubmitPerformanceWeightResult($input: SubmitWeightResultInput!) {
  submitWeightResult(input: $input) {
    ... on SubmitWeightResultSuccessfulResponse {
      result {
        ...WeightPerformanceResult
      }
    }
    ... on ErrorResponse {
      fields {
        message
        field
      }
    }
  }
}
    ${WeightPerformanceResultFragmentDoc}
${WeightPerformanceResultDataFragmentDoc}`;
export type SubmitPerformanceWeightResultMutationFn = Apollo.MutationFunction<SubmitPerformanceWeightResultMutation, SubmitPerformanceWeightResultMutationVariables>;

/**
 * __useSubmitPerformanceWeightResultMutation__
 *
 * To run a mutation, you first call `useSubmitPerformanceWeightResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPerformanceWeightResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPerformanceWeightResultMutation, { data, loading, error }] = useSubmitPerformanceWeightResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitPerformanceWeightResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitPerformanceWeightResultMutation, SubmitPerformanceWeightResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitPerformanceWeightResultMutation, SubmitPerformanceWeightResultMutationVariables>(SubmitPerformanceWeightResultDocument, options);
      }
export type SubmitPerformanceWeightResultMutationHookResult = ReturnType<typeof useSubmitPerformanceWeightResultMutation>;
export type SubmitPerformanceWeightResultMutationResult = Apollo.MutationResult<SubmitPerformanceWeightResultMutation>;
export type SubmitPerformanceWeightResultMutationOptions = Apollo.BaseMutationOptions<SubmitPerformanceWeightResultMutation, SubmitPerformanceWeightResultMutationVariables>;